import {
  SET_CART,
  SET_CART_LOADING,
  UNSET_CART_LOADING,
  IS_CART_SAVED,
} from '@/cart/context/types';

export default (state, action) => {
  switch (action.type) {
    case SET_CART:
      return {
        ...state,
        cart: action.payload,
      };
    case SET_CART_LOADING:
      return {
        ...state,
        cartLoading: true,
      };
    case UNSET_CART_LOADING:
      return {
        ...state,
        cartLoading: false,
      };
    case IS_CART_SAVED:
      return {
        ...state,
        isCartSaved: true,
      };
    default:
      return { ...state };
  }
};
